import React, { useEffect, useState } from 'react';
import './styles.scss';

const SharePage = () => {
  const [currentUrl, setCurrentUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showShareOptionsOnMobile, setShowShareOptionsOnMobile] = useState(false);

  const handleOnResize = () => {
    if (window.innerWidth < 992) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    if (window === 'undefined') return;

    setCurrentUrl(window.location.href);
    handleOnResize();

    window.addEventListener('resize', () => {
      handleOnResize();
    });

    return () => {
      window.removeEventListener('resize', () => {
        handleOnResize();
      });
    };
  }, []);

  return (
    <div className={`share-buttons-fixed ${isMobile ? 'mobile' : ''} ${showShareOptionsOnMobile ? 'show' : ''}`}>
      <span>Share</span>
      <div className="whatsapp">
        <a href={`https://wa.me/?text=${currentUrl}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path
              d="M23.9432 47.8864C37.1666 47.8864 47.8864 37.1666 47.8864 23.9432C47.8864 10.7197 37.1666 0 23.9432 0C10.7197 0 0 10.7197 0 23.9432C0 37.1666 10.7197 47.8864 23.9432 47.8864Z"
              fill="#E9E6EA"
            />
            <path
              d="M24.4753 11.7056C30.9403 11.7056 36.1808 16.9461 36.1808 23.4111C36.1808 29.8761 30.9403 35.1167 24.4753 35.1167C22.4067 35.12 20.3744 34.5726 18.5874 33.5306L12.7744 35.1167L14.357 29.3014C13.3141 27.5138 12.7663 25.4807 12.7697 23.4111C12.7697 16.9461 18.0103 11.7056 24.4753 11.7056ZM20.486 17.9095L20.2519 17.9189C20.1004 17.9281 19.9523 17.9679 19.8165 18.0359C19.6895 18.1079 19.5736 18.1977 19.4723 18.3028C19.3319 18.4351 19.2523 18.5498 19.1668 18.661C18.7338 19.2239 18.5008 19.915 18.5043 20.6252C18.5066 21.1988 18.6565 21.7571 18.8906 22.2792C19.3693 23.335 20.1571 24.4529 21.1966 25.4889C21.4471 25.7382 21.6929 25.9887 21.9574 26.2216C23.249 27.3588 24.7881 28.1788 26.4524 28.6166L27.1172 28.7184C27.3338 28.7301 27.5503 28.7137 27.7681 28.7032C28.109 28.6856 28.4419 28.5933 28.7431 28.4328C28.8965 28.3538 29.046 28.2679 29.1915 28.1753C29.1915 28.1753 29.2418 28.1425 29.3378 28.0699C29.4958 27.9529 29.593 27.8698 29.7241 27.7328C29.8212 27.6321 29.9055 27.5139 29.9699 27.3793C30.0612 27.1885 30.1525 26.8245 30.1899 26.5213C30.218 26.2895 30.2098 26.1631 30.2063 26.0847C30.2016 25.9594 30.0975 25.8295 29.9839 25.7745L29.3027 25.469C29.3027 25.469 28.2843 25.0253 27.6615 24.742C27.5964 24.7136 27.5266 24.6974 27.4555 24.6941C27.3754 24.6859 27.2945 24.6948 27.2182 24.7204C27.1419 24.7461 27.0719 24.7878 27.0131 24.8427C27.0072 24.8404 26.9288 24.9071 26.0825 25.9325C26.0339 25.9977 25.967 26.0471 25.8903 26.0742C25.8136 26.1013 25.7305 26.1049 25.6517 26.0847C25.5754 26.0642 25.5007 26.0384 25.4281 26.0074C25.283 25.9465 25.2326 25.9231 25.1331 25.881C24.4613 25.5878 23.8394 25.1917 23.2895 24.7069C23.142 24.5782 23.0051 24.4377 22.8646 24.3019C22.4041 23.8608 22.0028 23.362 21.6706 22.8177L21.6016 22.7064C21.552 22.6317 21.5119 22.5511 21.4822 22.4665C21.4377 22.2944 21.5536 22.1563 21.5536 22.1563C21.5536 22.1563 21.838 21.8449 21.9703 21.6764C22.0991 21.5125 22.2079 21.3533 22.2782 21.2397C22.4163 21.0173 22.4596 20.7891 22.387 20.6123C22.0593 19.8117 21.7198 19.0145 21.371 18.2232C21.3019 18.0664 21.0971 17.954 20.9109 17.9318C20.8477 17.9247 20.7845 17.9177 20.7213 17.913C20.5641 17.9053 20.4066 17.9067 20.2496 17.9177L20.4849 17.9083L20.486 17.9095Z"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>
      <div className="twitter">
        <a href={`http://twitter.com/share?url=${currentUrl}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
            <path
              d="M23.9432 48.0227C37.1666 48.0227 47.8864 37.303 47.8864 24.0795C47.8864 10.8561 37.1666 0.136353 23.9432 0.136353C10.7197 0.136353 0 10.8561 0 24.0795C0 37.303 10.7197 48.0227 23.9432 48.0227Z"
              fill="#E9E6EA"
            />
            <path
              d="M26.5021 22.9831L34.4264 13.9702H32.5492L25.6657 21.7943L20.1719 13.9702H13.8339L22.1434 25.8028L13.8339 35.253H15.711L22.9756 26.9887L28.7787 35.253H35.1167M16.3885 15.3553H19.2724L32.5479 33.9361H29.6633"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>
      <div className="linkedin">
        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path
              d="M23.9432 47.0454C37.1666 47.0454 47.8864 36.575 47.8864 23.6591C47.8864 10.7431 37.1666 0.272705 23.9432 0.272705C10.7197 0.272705 0 10.7431 0 23.6591C0 36.575 10.7197 47.0454 23.9432 47.0454Z"
              fill="#E9E6EA"
            />
            <path
              d="M19.1855 31.4545H15.2144V19.6574H19.1855V31.4545ZM17.1978 18.0481C15.928 18.0481 14.898 17.0778 14.898 15.9064C14.898 15.3437 15.1403 14.804 15.5716 14.4061C16.0029 14.0084 16.5879 13.7848 17.1978 13.7848C17.8078 13.7848 18.3928 14.0084 18.8241 14.4061C19.2553 14.804 19.4977 15.3437 19.4977 15.9064C19.4977 17.0778 18.4672 18.0481 17.1978 18.0481ZM34.0483 31.4545H30.0856V25.7117C30.0856 24.3431 30.0557 22.5879 28.021 22.5879C25.9564 22.5879 25.64 24.0749 25.64 25.6131V31.4545H21.6731V19.6574H25.4817V21.2666H25.5373C26.0676 20.3397 27.3626 19.3616 29.2947 19.3616C33.3137 19.3616 34.0526 21.803 34.0526 24.9742V31.4545H34.0483Z"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>
      <div className="facebook">
        <a href={`http://www.facebook.com/share.php?u=${currentUrl}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="50" viewBox="0 0 49 50" fill="none">
            <path
              d="M24.5 49.2954C38.031 49.2954 49 38.3264 49 24.7954C49 11.2644 38.031 0.29541 24.5 0.29541C10.969 0.29541 0 11.2644 0 24.7954C0 38.3264 10.969 49.2954 24.5 49.2954Z"
              fill="#E9E6EA"
            />
            <path
              d="M26.8593 26.6882H30.2296L31.5778 21.2955H26.8593V18.5992C26.8593 17.2107 26.8593 15.9029 29.5556 15.9029H31.5778V11.3732C31.1383 11.3152 29.4787 11.1844 27.7262 11.1844C24.0659 11.1844 21.4667 13.4183 21.4667 17.5207V21.2955H17.4222V26.6882H21.4667V38.1474H26.8593V26.6882Z"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>
      <div className="bluesky">
        <a href={`https://bsky.app/intent/compose?text=${currentUrl}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
            <path
              d="M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z"
              fill="#E9E6EA"
            />
            <path
              d="M25 24.6598C23.8222 22.3814 20.6164 18.1339 17.6355 16.0406C14.7794 14.0352 13.6913 14.3807 12.9776 14.7041C12.1508 15.0728 12 16.3369 12 17.0782C12 17.8221 12.4095 23.1706 12.676 24.0647C13.56 27.0145 16.6982 28.0107 19.592 27.6911C15.354 28.316 11.5879 29.8518 16.524 35.3219C21.9554 40.9175 23.9678 34.1225 25 30.6772C26.0322 34.1225 27.2204 40.673 33.3772 35.3219C38 30.6772 34.6473 28.316 30.4093 27.6911C33.3018 28.0107 36.4413 27.0145 37.324 24.0647C37.5905 23.1719 38 17.8221 38 17.0795C38 16.3356 37.8492 15.0741 37.0224 14.7015C36.3087 14.3807 35.2206 14.0326 32.3645 16.038C29.3836 18.1352 26.1765 22.3827 25 24.6598Z"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>
      <div className="mail">
        <a target="_blank" href={`mailto:/?body=Hello! Check this ${currentUrl}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="50" viewBox="0 0 49 50" fill="none">
            <path
              d="M24.5 49.4319C38.031 49.4319 49 38.4629 49 24.9319C49 11.4009 38.031 0.431885 24.5 0.431885C10.969 0.431885 0 11.4009 0 24.9319C0 38.4629 10.969 49.4319 24.5 49.4319Z"
              fill="#E9E6EA"
            />
            <path d="M10.6334 15.6763V15.708L25.0518 25.6009L39.456 15.7184V15.6764L10.6334 15.6763Z" fill="#184B31" />
            <path d="M28.033 24.939L40.2889 33.3483V16.5303L28.033 24.939Z" fill="#184B31" />
            <path d="M9.79999 16.5205V33.3585L22.0707 24.9391L9.79999 16.5205Z" fill="#184B31" />
            <path
              d="M27.1993 25.7517L25.0517 27.2239L22.9038 25.7517L10.6332 34.1696V34.1872H39.4557V34.1599L27.1993 25.7517Z"
              fill="#184B31"
            />
          </svg>
        </a>
      </div>

      {isMobile && (
        <div
          className={`close ${!showShareOptionsOnMobile ? 'show-icon' : ''}`}
          onClick={() => setShowShareOptionsOnMobile((prev) => !prev)}
        >
          {!showShareOptionsOnMobile ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
              <rect width="45" height="45" rx="5" fill="white" />
              <path
                d="M25.0757 27.7716L19.9657 24.9846C19.4752 25.4715 18.8515 25.8023 18.1733 25.9352C17.4951 26.0682 16.7927 25.9974 16.1546 25.7317C15.5166 25.466 14.9715 25.0174 14.5881 24.4424C14.2046 23.8674 14 23.1917 14 22.5006C14 21.8095 14.2046 21.1338 14.5881 20.5588C14.9715 19.9838 15.5166 19.5352 16.1546 19.2695C16.7927 19.0038 17.4951 18.933 18.1733 19.066C18.8515 19.1989 19.4752 19.5297 19.9657 20.0166L25.0757 17.2296C24.9005 16.4073 25.027 15.5495 25.4323 14.8129C25.8376 14.0762 26.4945 13.5101 27.2828 13.218C28.0712 12.9259 28.9383 12.9274 29.7257 13.2221C30.5131 13.5168 31.1681 14.0851 31.5709 14.823C31.9737 15.561 32.0975 16.4193 31.9195 17.241C31.7415 18.0626 31.2737 18.7928 30.6016 19.2979C29.9295 19.803 29.0981 20.0493 28.2593 19.9918C27.4206 19.9343 26.6305 19.5767 26.0337 18.9846L20.9237 21.7716C21.0259 22.2519 21.0259 22.7483 20.9237 23.2286L26.0337 26.0166C26.6305 25.4245 27.4206 25.0669 28.2593 25.0094C29.0981 24.9519 29.9295 25.1982 30.6016 25.7033C31.2737 26.2084 31.7415 26.9386 31.9195 27.7602C32.0975 28.5819 31.9737 29.4402 31.5709 30.1782C31.1681 30.9161 30.5131 31.4844 29.7257 31.7791C28.9383 32.0738 28.0712 32.0753 27.2828 31.7832C26.4945 31.4911 25.8376 30.925 25.4323 30.1883C25.027 29.4517 24.9005 28.5939 25.0757 27.7716Z"
                fill="#184B31"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
              <circle cx="22.5" cy="22.5" r="22.5" fill="#DDF1E0" />
              <path
                d="M32 14.9136L30.0864 13L22.5 20.5864L14.9136 13L13 14.9136L20.5864 22.5L13 30.0864L14.9136 32L22.5 24.4136L30.0864 32L32 30.0864L24.4136 22.5L32 14.9136Z"
                fill="#184B31"
              />
            </svg>
          )}
        </div>
      )}
    </div>
  );
};

export default SharePage;
